import { useTranslation } from 'react-i18next'
import React from 'react'

import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useModalData } from '../../../../components/modals/ModalsContext'
import CardPicker from '../../../../packages/kiti/components/form/CardPicker'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import DocumentInput from '../../../../components/form/DocumentInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import PlaceTypeSelect from '../../../../containers/places/select/PlaceTypeSelect'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Textarea from '../../../../packages/kiti/components/form/Textarea'

const ENTITIES_WITH_CHECKLIST = ['service_order']
const ENTITIES_WITH_PLACE_TYPE = ['service_order']
const TYPES = [
  { id: 'dynamic_pdf', name: 'PDF', icon: 'RiFilePdfLine' },
  { id: 'docx', name: 'DOCX', icon: 'RiFileWordLine' }
]

const GeneralSection = () => {
  const { t } = useTranslation('templates')
  const { entity } = useModalData()
  const form = useForm()

  return (
    <>
      <FormItem label={`${t('name')}*`} field="name" />
      <Separator weight={2} />

      <FormItem label={t('description')} field="description" Input={Textarea} limit={255} rows={5} />
      <Separator weight={2} />

      {ENTITIES_WITH_CHECKLIST.includes(entity) && (
        <>
          <FormItem label={t('exclusiveForChecklist')} field="checklist" Input={ChecklistSelect} />
          <Separator weight={2} />
        </>
      )}

      {ENTITIES_WITH_PLACE_TYPE.includes(entity) && (
        <>
          <FormItem label={t('exclusiveForPlaceType')} field="placeType" Input={PlaceTypeSelect} />
          <Separator weight={2} />
        </>
      )}

      <FormItem label={t('type')} field="type" Input={CardPicker} options={TYPES} selectOnlyId />
      <Separator weight={2} />

      {form.type === 'docx' && (
        <FormItem
          label={`${t('document')}*`}
          buttonLabel={`${t('input.addDocument')}*`}
          field="document"
          Input={DocumentInput}
          colWidth="60%"
          accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        />
      )}
    </>
  )
}

export default GeneralSection
